var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradeBadge = function SvgGradeBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 76,
    fill: "none",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8D270",
    fillRule: "evenodd",
    d: "M38.502.007c2.05-.087 3.666.624 5.295 1.653 2.068 1.303 4.4 3.885 7.276 5.519 4.041 2.3 11.536-.873 15.37 4.801 2.238 3.306 2.344 5.9 2.508 8.463.181 2.762.664 5.307 3.509 9.048 4.706 6.193 5.683 10.315 3.258 14.611-1.654 2.931-5.132 4.559-5.94 6.411-1.711 3.948.181 6.922-2.162 11.524-1.63 3.193-4.142 5.295-7.489 6.367-2.82.905-5.658-.405-7.914.543-3.973 1.659-6.9 5.519-10.064 6.498a12.2 12.2 0 0 1-3.647.555 12 12 0 0 1-3.647-.555c-3.158-.98-6.09-4.833-10.063-6.498-2.263-.948-5.095.362-7.915-.543-3.346-1.072-5.859-3.174-7.488-6.367-2.35-4.602-.451-7.576-2.168-11.524-.808-1.852-4.286-3.48-5.94-6.41-2.426-4.297-1.442-8.42 3.258-14.612 2.845-3.741 3.327-6.286 3.509-9.048.17-2.563.27-5.157 2.507-8.463 3.835-5.674 11.33-2.5 15.37-4.801 2.877-1.634 5.202-4.216 7.276-5.52C34.837.632 36.453-.08 38.502.008",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 26.5,
    fill: "#F6EDC6",
    stroke: "#BD9D0F"
  })));
};
export default SvgGradeBadge;